import React from "react";
import { Error, Button } from "@pga/pga-component-library";

export const BLOCK_APP_ACCESS = false;

export const BlockAppAccessMessage = () => (
  <div>
    <h3>PGA.org is undergoing maintenance.</h3>
    <p className="mt-3">
      We are sorry for the inconvenience. You can still access Resources and the
      Directory, and we will have everything back online as quickly as we can.
    </p>
    <Button href="https://resources.pga.org" className="m-2">
      Resources
    </Button>
    <Button href="https://directory.pga.org" className="m-2">
      Directory
    </Button>
  </div>
);

export const BlockAppAccess = () => <Error Message={BlockAppAccessMessage} />;
